import { mount } from 'svelte';
import { Buffer } from 'buffer';
import '@escrodesk/ui/styles.css';
import './styles/app.css';

const browserGlobal = globalThis as typeof globalThis & {
  Buffer?: typeof Buffer;
  global?: typeof globalThis;
  process?: { env: Record<string, string | undefined> };
};

browserGlobal.Buffer ??= Buffer;
browserGlobal.global ??= globalThis;
browserGlobal.process ??= { env: {} } as typeof browserGlobal.process;

if (import.meta.env.DEV && window.location.hostname === '0.0.0.0') {
  window.location.replace(`http://localhost:${window.location.port}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const app = import('./App.svelte').then(({ default: App }) => mount(App, { target: document.getElementById('app')! }));
export default app;
